module.exports = __webpack_public_path__ + "img/maximize-alt.4459b0be.svg";